module.exports = __webpack_public_path__ + "img/qc-charts.866200ba.svg";